(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["keo-bundle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-keo-bundle]').forEach(function (root) {
      var discount = parseFloat(root.dataset.discountPercent || '15') / 100;
      var size = null;
      var topColour = null;
      var bottomColour = null;
      var socksToggle = root.querySelector('[data-socks-toggle]');
      var priceNow = root.querySelector('[data-bundle-price-now]');
      var priceCompare = root.querySelector('[data-bundle-price-compare]');
      var addBtn = root.querySelector('.keo-bundle__add-btn');
      var status = root.querySelector('[data-bundle-status]');
      var topImg = root.querySelector('[data-top-img]');
      var bottomImg = root.querySelector('[data-bottom-img]');

      var topMap = {}, bottomMap = {};
      try { topMap = JSON.parse((root.querySelector('[data-top-variant-map]') || {}).textContent || '{}'); } catch (e) {}
      try { bottomMap = JSON.parse((root.querySelector('[data-bottom-variant-map]') || {}).textContent || '{}'); } catch (e) {}

      function activeIn(sel) { return root.querySelector(sel + '[aria-pressed="true"]'); }
      function setActive(group, btn) {
        root.querySelectorAll(group).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
      }
      function firstImageForColour(map, colour) {
        var key = Object.keys(map).filter(function (k) { return k.indexOf(colour + '|') === 0; })[0];
        return key ? map[key].image : null;
      }

      var topInitial = activeIn('[data-top-swatch]');
      var bottomInitial = activeIn('[data-bottom-swatch]');
      topColour = topInitial ? topInitial.dataset.colour : null;
      bottomColour = bottomInitial ? bottomInitial.dataset.colour : null;

      root.querySelectorAll('[data-top-swatch]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setActive('[data-top-swatch]', btn);
          topColour = btn.dataset.colour;
          var img = firstImageForColour(topMap, topColour);
          if (topImg && img) topImg.src = img;
          recalc();
        });
      });
      root.querySelectorAll('[data-bottom-swatch]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setActive('[data-bottom-swatch]', btn);
          bottomColour = btn.dataset.colour;
          var img = firstImageForColour(bottomMap, bottomColour);
          if (bottomImg && img) bottomImg.src = img;
          recalc();
        });
      });
      root.querySelectorAll('[data-size-picker] .keo-size-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          root.querySelectorAll('[data-size-picker] .keo-size-btn').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          btn.setAttribute('aria-pressed', 'true');
          size = btn.dataset.size;
          recalc();
        });
      });
      if (socksToggle) socksToggle.addEventListener('change', recalc);

      function topInfo() { return (topColour && size) ? topMap[topColour + '|' + size] : null; }
      function bottomInfo() { return (bottomColour && size) ? bottomMap[bottomColour + '|' + size] : null; }

      function recalc() {
        var top = topInfo();
        var bottom = bottomInfo();
        var full = 0;
        if (top) full += parseFloat(top.price || '0') / 100;
        if (bottom) full += parseFloat(bottom.price || '0') / 100;
        var socksPrice = parseFloat(root.dataset.socksPrice || '0') / 100;
        if (socksToggle && socksToggle.checked) full += socksPrice;
        var discounted = Math.round(full * (1 - discount) * 100) / 100;
        if (priceNow) priceNow.textContent = formatMoney(discounted);
        if (priceCompare) priceCompare.textContent = formatMoney(full);
        if (addBtn) addBtn.textContent = size ? 'Add the set to bag' : 'Select a size';
      }

      function formatMoney(amount) {
        return (root.dataset.currencySymbol || '') + amount.toFixed(2);
      }

      if (addBtn) {
        addBtn.addEventListener('click', function (e) {
          e.preventDefault();
          if (!size) return;
          var top = topInfo();
          var bottom = bottomInfo();
          if (!top || !bottom || !top.available || !bottom.available) {
            if (status) { status.hidden = false; status.textContent = 'That size isn\'t available in one of your colours — try another.'; }
            return;
          }
          var items = [
            { id: top.id, quantity: 1 },
            { id: bottom.id, quantity: 1 }
          ];
          if (root.dataset.socksVariantId && socksToggle && socksToggle.checked) {
            items.push({ id: root.dataset.socksVariantId, quantity: 1 });
          }
          if (status) { status.hidden = false; status.textContent = 'Adding to bag…'; }
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          }).then(function () {
            return window.keoApplyDiscount ? window.keoApplyDiscount('KEOSET15') : Promise.resolve();
          }).then(function () {
            if (status) status.textContent = 'Added to your bag — 15% off applied.';
            if (window.keoRefreshCartDrawer) window.keoRefreshCartDrawer(true);
          }).catch(function () {
            if (status) status.textContent = 'Choose a size for both items and try again.';
          });
        });
      }

      recalc();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keo-complete-the-set"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function money(cents, symbol) { return symbol + (cents / 100).toFixed(2); }

    function initCts(root) {
      if (!root || root.dataset.keoCtsReady) return;
      root.dataset.keoCtsReady = '1';
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-cts-item]'));
      var priceEl = root.querySelector('[data-cts-price]');
      var countEl = root.querySelector('[data-cts-count]');
      var noteEl = root.querySelector('[data-cts-note]');
      var addBtn = root.querySelector('.keo-cts__add-btn');
      var discount = parseFloat(root.dataset.discountPercent || '15') / 100;
      var symbol = root.dataset.currencySymbol || '';
      var noteText = noteEl ? noteEl.textContent : '';

      items.forEach(function (item) {
        try { item._variants = JSON.parse(item.querySelector('[data-cts-variants]').textContent); } catch (e) { item._variants = []; }
      });

      // The variant matching every chosen option, or null while one is unset.
      function chosen(item) {
        var selects = item.querySelectorAll('[data-cts-option]');
        var wanted = [];
        for (var i = 0; i < selects.length; i++) {
          if (!selects[i].value) return null;
          wanted[parseInt(selects[i].dataset.ctsOption, 10)] = selects[i].value;
        }
        return item._variants.find(function (v) {
          return v.options.every(function (o, i) { return wanted[i] === undefined || wanted[i] === o; });
        }) || null;
      }

      // Any variant in the chosen colour etc., used for price/image before a size is set.
      function closest(item) {
        var selects = item.querySelectorAll('[data-cts-option]');
        var best = null, bestScore = -1;
        item._variants.forEach(function (v) {
          var score = 0;
          selects.forEach(function (sel) { if (sel.value && v.options[parseInt(sel.dataset.ctsOption, 10)] === sel.value) score++; });
          if (score > bestScore) { best = v; bestScore = score; }
        });
        return best;
      }

      function update(item) {
        var v = chosen(item) || closest(item);
        if (!v) return;
        var priceNow = item.querySelector('.keo-price__now');
        if (priceNow) priceNow.textContent = money(v.price, symbol);
        var was = item.querySelector('.keo-price__was, .keo-price__compare, s');
        if (was) {
          if (v.compare_at_price && v.compare_at_price > v.price) { was.textContent = money(v.compare_at_price, symbol); was.hidden = false; }
          else was.hidden = true;
        }
        var img = item.querySelector('.keo-cts__img img');
        if (img && v.image) { img.src = v.image; img.removeAttribute('srcset'); }
        item.querySelectorAll('[data-cts-option]').forEach(function (sel) {
          // Mark sizes that are sold out in the chosen colour.
          if (!sel.options) return;
          var idx = parseInt(sel.dataset.ctsOption, 10);
          Array.prototype.forEach.call(sel.options, function (opt) {
            if (!opt.value) return;
            var other = item._variants.filter(function (x) {
              if (x.options[idx] !== opt.value) return false;
              return Array.prototype.every.call(item.querySelectorAll('[data-cts-option]'), function (s2) {
                var j = parseInt(s2.dataset.ctsOption, 10);
                return j === idx || !s2.value || x.options[j] === s2.value;
              });
            });
            var avail = other.some(function (x) { return x.available; });
            opt.disabled = !avail;
            opt.textContent = opt.value + (avail ? '' : ' (sold out)');
          });
        });
        item._price = v.price;
      }

      function recalc() {
        var sum = 0, count = 0;
        items.forEach(function (item) {
          var t = item.querySelector('[data-cts-toggle]');
          if (t && t.checked) { sum += item._price || 0; count++; }
        });
        var hasDiscount = count > 1;
        var final = hasDiscount ? sum * (1 - discount) : sum;
        if (priceEl) priceEl.textContent = money(Math.round(final), symbol);
        if (countEl) countEl.textContent = count + (count === 1 ? ' item' : ' items') + (hasDiscount ? ' · ' + Math.round(discount * 100) + '% off the set' : '');
      }

      items.forEach(function (item) {
        item.querySelectorAll('[data-cts-option]').forEach(function (sel) {
          sel.addEventListener('change', function () {
            sel.classList.remove('is-missing');
            update(item); recalc();
            if (noteEl) { noteEl.textContent = noteText; noteEl.classList.remove('is-error'); }
          });
        });
        var t = item.querySelector('[data-cts-toggle]');
        if (t) t.addEventListener('change', recalc);
        update(item);
      });
      recalc();

      // Keep "This item" in step with the colour and size chosen in the main
      // product form; a size picked there also fills any size unset here.
      function setSelect(sel, value) {
        if (!sel || !sel.options) return false;
        var match = Array.prototype.find.call(sel.options, function (o) { return o.value === value && !o.disabled; });
        if (!match) return false;
        sel.value = value; sel.classList.remove('is-missing');
        return true;
      }
      function syncFromProductForm(fillOthers) {
        var colourBtn = document.querySelector('[data-keo-colour-picker] .keo-swatch[aria-pressed="true"]');
        var sizeBtn = document.querySelector('[data-keo-size-picker] .keo-size-btn[aria-pressed="true"]');
        items.forEach(function (item) {
          var isCurrent = item.hasAttribute('data-cts-current');
          var changed = false;
          item.querySelectorAll('select[data-cts-option]').forEach(function (sel) {
            if (sel.hasAttribute('data-cts-size')) {
              if (sizeBtn && (isCurrent || (fillOthers && !sel.value))) changed = setSelect(sel, sizeBtn.dataset.size) || changed;
            } else if (isCurrent && colourBtn) {
              changed = setSelect(sel, colourBtn.dataset.colour) || changed;
            }
          });
          if (changed) update(item);
        });
        recalc();
      }
      syncFromProductForm(false);
      document.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('[data-keo-colour-picker] .keo-swatch, [data-keo-size-picker] .keo-size-btn');
        if (!btn || !root.isConnected) return;
        var isSize = btn.classList.contains('keo-size-btn');
        setTimeout(function () { syncFromProductForm(isSize); }, 0);
      });

      if (addBtn) {
        addBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var lines = [], missing = false;
          items.forEach(function (item) {
            var t = item.querySelector('[data-cts-toggle]');
            if (!t || !t.checked) return;
            var v = chosen(item);
            if (!v) {
              missing = true;
              item.querySelectorAll('[data-cts-option]').forEach(function (sel) { if (!sel.value) sel.classList.add('is-missing'); });
              return;
            }
            lines.push({ id: v.id, quantity: 1 });
          });
          if (missing) {
            if (noteEl) { noteEl.textContent = 'Please choose a size for each piece.'; noteEl.classList.add('is-error'); }
            return;
          }
          if (!lines.length) return;
          var label = addBtn.textContent;
          addBtn.disabled = true;
          var shouldDiscount = lines.length > 1;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: lines })
          }).then(function (r) {
            if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'add failed'); });
            return r.json();
          }).then(function () {
            return (shouldDiscount && window.keoApplyDiscount) ? window.keoApplyDiscount('KEOSET15') : null;
          }).then(function () {
            if (window.keoRefreshCartDrawer) window.keoRefreshCartDrawer(true);
            addBtn.textContent = 'Added ✓';
          }).catch(function (err) {
            if (noteEl) { noteEl.textContent = err.message || 'Something went wrong. Please try again.'; noteEl.classList.add('is-error'); }
          }).finally(function () {
            setTimeout(function () { addBtn.textContent = label; addBtn.disabled = false; }, 1500);
          });
        });
      }
    }

    function initAll(scope) { (scope || document).querySelectorAll('[data-keo-cts]').forEach(initCts); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keo-header"]) return;
  try {
    
  (function () {
    // Warm the mega-menu images as soon as the pointer enters the header so
    // they're ready by the time the menu opens (still lazy on touch/mobile).
    var headerEl = document.getElementById('keo-header');
    if (headerEl) headerEl.addEventListener('mouseenter', function () {
      headerEl.querySelectorAll('.keo-mega img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
    }, { once: true });

    // Mega menu hover intent: stays open briefly after the pointer leaves so
    // moving diagonally from "Shop" to the panel doesn't close it.
    document.querySelectorAll('.keo-header__nav-item').forEach(function (item) {
      if (!item.querySelector('.keo-mega')) return;
      var closeTimer = null;
      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        document.querySelectorAll('.keo-header__nav-item.is-open').forEach(function (o) { if (o !== item) o.classList.remove('is-open'); });
        item.classList.add('is-open');
      });
      item.addEventListener('mouseleave', function () {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () { item.classList.remove('is-open'); }, 250);
      });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { item.classList.remove('is-open'); var l = item.querySelector('a'); if (l) l.focus(); }
      });
    });

    var wrap = document.querySelector('.keo-header-wrap[data-transparent-home]');
    var group = document.getElementById('header-group');
    var menuBtn = document.querySelector('[data-keo-menu-open]');
    var menu = document.querySelector('[data-keo-menu]');

    // Horizon scrolls inside .page-wrapper on desktop (>=990px) and the
    // window on mobile, so read whichever is actually scrolling.
    var pageWrapper = document.querySelector('.page-wrapper');
    // Work out which element actually scrolls (Horizon scrolls .page-wrapper
    // on desktop, the window on mobile) once, and again only on resize, so
    // the scroll handler never forces a layout read of the whole page.
    var scroller = null;
    var headerH = 108;
    function measure() {
      var pwScrolls = pageWrapper && getComputedStyle(pageWrapper).overflowY !== 'visible' && pageWrapper.scrollHeight > pageWrapper.clientHeight;
      scroller = pwScrolls ? pageWrapper : null;
      headerH = (wrap && wrap.offsetHeight) || 108;
    }
    function scrollTop() {
      return scroller ? scroller.scrollTop : (window.scrollY || document.documentElement.scrollTop || 0);
    }
    measure();
    // Switching between desktop and mobile (e.g. the theme editor's device
    // toggle) changes which element scrolls; reset everything so the header
    // can't get stuck hidden, a menu can't stay open, and the scroll baseline
    // is fresh.
    var resizeTimer = null;
    var wasDesktop = window.matchMedia('(min-width: 990px)').matches;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        measure();
        lastY = scrollTop();
        if (group) group.classList.remove('keo-header-group--hidden');
        var isDesktop = window.matchMedia('(min-width: 990px)').matches;
        if (isDesktop !== wasDesktop) {
          if (menu) menu.removeAttribute('data-open');
          document.querySelectorAll('.keo-header__nav-item.is-open').forEach(function (i) { i.classList.remove('is-open'); });
          wasDesktop = isDesktop;
        }
        onScroll();
      }, 150);
    }, { passive: true });
    window.addEventListener('load', function () { measure(); });

    var lastY = scrollTop();
    var ticking = false;
    var hovering = false;
    if (wrap && window.matchMedia('(hover: hover)').matches) {
      wrap.addEventListener('mouseenter', function () { hovering = true; });
      wrap.addEventListener('mouseleave', function () { hovering = false; });
    }
    function onScroll(e) {
      // Ignore sideways/inner scrolls (reel rails, galleries, drawers).
      var t = e && e.target;
      if (t && t !== document && t !== document.documentElement && t !== document.body && t !== pageWrapper) return;
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var y = scrollTop();

        if (wrap && wrap.dataset.transparentHome === 'true') {
          var clear = y <= 40;
          if (clear !== wrap.hasAttribute('data-keo-clear')) {
            if (clear) wrap.setAttribute('data-keo-clear', '');
            else wrap.removeAttribute('data-keo-clear');
          }
        }

        if (wrap && group && wrap.dataset.stickyMode === 'scroll_up') {
          var menuOpen = menu && menu.hasAttribute('data-open');
          var delta = y - lastY;
          if (y <= headerH || menuOpen || hovering) {
            group.classList.remove('keo-header-group--hidden');
          } else if (delta > 6) {
            group.classList.add('keo-header-group--hidden');
          } else if (delta < -6) {
            group.classList.remove('keo-header-group--hidden');
          }
        }
        lastY = y;
      });
    }
    onScroll();
    // Capture phase catches scroll events from .page-wrapper as well as the window.
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    if (group && wrap) {
      wrap.addEventListener('focusin', function () { group.classList.remove('keo-header-group--hidden'); });
    }

    if (menuBtn && menu) {
      menuBtn.addEventListener('click', function () {
        if (menu.hasAttribute('data-open')) {
          menu.removeAttribute('data-open');
        } else {
          menu.setAttribute('data-open', '');
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keo-product-main"]) return;
  try {
    
  (function () {
    // Set up per product section. Re-run when the theme editor re-renders it,
    // otherwise colour/size, gallery and sticky bar stop responding.
    function initPdp(root) {
      if (!root || root.dataset.keoPdpReady) return;
      root.dataset.keoPdpReady = 'true';
      var form = root.querySelector('#KeoProductForm') || document.getElementById('KeoProductForm');
      var variantInput = root.querySelector('[data-keo-variant-input]');
      var addBtn = root.querySelector('[data-keo-add-btn]');
      var qtyInput = root.querySelector('[data-qty-input]');

      var variantMapEl = root.querySelector('[data-keo-variant-map]');
      var variantMap = {};
      try { variantMap = JSON.parse((variantMapEl && variantMapEl.textContent) || '{}'); } catch (e) {}
      var gallery = root.querySelector('[data-keo-gallery]');
      var colourPicker = root.querySelector('[data-keo-colour-picker]');
      var colourCurrentEl = root.querySelector('[data-keo-colour-current]');
      var lowStockEl = root.querySelector('[data-keo-low-stock]');
      var pressedColourBtn = colourPicker && colourPicker.querySelector('.keo-swatch[aria-pressed="true"]');
      var pressedSizeBtn = root.querySelector('[data-keo-size-picker] .keo-size-btn[aria-pressed="true"]');
      // No swatch row when there's only one colour, so fall back to the
      // server-rendered colour or every map lookup misses.
      var selectedColour = pressedColourBtn ? pressedColourBtn.dataset.colour : (variantMapEl ? variantMapEl.dataset.currentColour : null);
      var selectedSize = pressedSizeBtn ? pressedSizeBtn.dataset.size : null;

      // Mobile carousel indicator (dots / counter / progress). Rebuilt whenever
      // the visible set changes, because picking a colour hides other
      // colourways' images.
      var galleryNav = root.querySelector('[data-keo-gallery-nav]');
      function visibleItems() {
        return gallery ? Array.prototype.filter.call(gallery.children, function (el) { return !el.hidden; }) : [];
      }
      function activeIndex(items) {
        if (!items.length) return 0;
        var left = gallery.getBoundingClientRect().left;
        var best = 0, bestDist = Infinity;
        items.forEach(function (el, i) {
          var d = Math.abs(el.getBoundingClientRect().left - left - (parseFloat(getComputedStyle(gallery).paddingLeft) || 0));
          if (d < bestDist) { bestDist = d; best = i; }
        });
        return best;
      }
      function updateGalleryNav() {
        if (!galleryNav || !gallery) return;
        var items = visibleItems();
        var idx = activeIndex(items);
        galleryNav.hidden = items.length < 2;
        var dots = galleryNav.querySelector('[data-keo-gallery-dots]');
        if (dots) {
          if (dots.children.length !== items.length) {
            dots.innerHTML = '';
            items.forEach(function () { dots.appendChild(document.createElement('span')); });
          }
          Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-active', i === idx); });
        }
        var indexEl = galleryNav.querySelector('[data-keo-gallery-index]');
        var totalEl = galleryNav.querySelector('[data-keo-gallery-total]');
        if (indexEl) indexEl.textContent = idx + 1;
        if (totalEl) totalEl.textContent = items.length;
        var bar = galleryNav.querySelector('[data-keo-gallery-bar]');
        if (bar && items.length) { bar.style.width = (100 / items.length) + '%'; bar.style.left = (idx * 100 / items.length) + '%'; }
      }
      if (gallery && galleryNav) {
        var navTick = null;
        gallery.addEventListener('scroll', function () {
          if (navTick) return;
          navTick = requestAnimationFrame(function () { navTick = null; updateGalleryNav(); });
        }, { passive: true });
        window.addEventListener('resize', updateGalleryNav);
      }

      var sticky = root.querySelector('[data-keo-sticky-atc]');
      var stickyBtn = sticky && sticky.querySelector('[data-keo-sticky-add]');
      var stickyVariant = sticky && sticky.querySelector('[data-keo-sticky-variant]');
      var stickyPrice = sticky && sticky.querySelector('[data-keo-sticky-price]');
      var stickyImg = sticky && sticky.querySelector('[data-keo-sticky-img]');

      function applySelection() {
        var info = selectedColour != null && selectedSize != null ? variantMap[selectedColour + '|' + selectedSize] : null;
        if (!info) {
          var fallbackKey = Object.keys(variantMap).filter(function (k) { return k.indexOf(selectedColour + '|') === 0; })[0];
          if (fallbackKey) { info = variantMap[fallbackKey]; selectedSize = fallbackKey.split('|')[1]; }
        }
        if (!info) return;
        if (variantInput) variantInput.value = info.id;
        if (addBtn) { addBtn.disabled = !info.available; addBtn.textContent = info.available ? 'Add to bag' : 'Sold out'; }
        if (stickyBtn) { stickyBtn.disabled = !info.available; stickyBtn.textContent = info.available ? 'Add to bag' : 'Sold out'; }
        if (stickyVariant) stickyVariant.textContent = [selectedColour, selectedSize].filter(Boolean).join(' / ');
        if (stickyPrice && info.price) stickyPrice.textContent = info.price;
        if (stickyImg && gallery) {
          var firstVisible = gallery.querySelector('.keo-pdp__gallery-item:not([hidden]) img');
          if (firstVisible) stickyImg.src = firstVisible.currentSrc || firstVisible.src;
        }
        if (colourCurrentEl && selectedColour) colourCurrentEl.textContent = selectedColour;
        if (gallery && selectedColour) {
          gallery.querySelectorAll('[data-colour]').forEach(function (item) {
            item.hidden = item.dataset.colour !== selectedColour;
          });
          gallery.scrollLeft = 0;
          updateGalleryNav();
        }
        if (lowStockEl) {
          var threshold = parseInt(lowStockEl.dataset.threshold || '0', 10);
          if (threshold > 0 && info.available && info.qty > 0 && info.qty <= threshold) {
            lowStockEl.hidden = false;
            var qtyEl = lowStockEl.querySelector('[data-keo-low-stock-qty]');
            var colEl = lowStockEl.querySelector('[data-keo-low-stock-colour]');
            if (qtyEl) qtyEl.textContent = info.qty;
            if (colEl) colEl.textContent = selectedColour ? ' in ' + selectedColour : '';
          } else {
            lowStockEl.hidden = true;
          }
        }
        if (colourPicker) {
          colourPicker.querySelectorAll('.keo-swatch').forEach(function (sw) {
            sw.setAttribute('aria-pressed', sw.dataset.colour === selectedColour ? 'true' : 'false');
          });
        }
        root.querySelectorAll('[data-keo-size-picker] .keo-size-btn').forEach(function (btn) {
          var sizeInfo = variantMap[selectedColour + '|' + btn.dataset.size];
          btn.disabled = !(sizeInfo && sizeInfo.available);
          btn.setAttribute('aria-pressed', btn.dataset.size === selectedSize ? 'true' : 'false');
        });
      }

      if (colourPicker) {
        colourPicker.querySelectorAll('.keo-swatch').forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (btn.dataset.colour === selectedColour) return;
            selectedColour = btn.dataset.colour;
            applySelection();
          });
        });
      }

      root.querySelectorAll('[data-keo-size-picker] .keo-size-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          selectedSize = btn.dataset.size;
          applySelection();
        });
      });

      applySelection();
      updateGalleryNav();

      var decrease = root.querySelector('[data-qty-decrease]');
      var increase = root.querySelector('[data-qty-increase]');
      if (decrease && qtyInput) decrease.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
      if (increase && qtyInput) increase.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });

      if (sticky && 'IntersectionObserver' in window) {
        var buyRow = root.querySelector('.keo-pdp__buy-row');
        var setVisible = function (on) {
          sticky.classList.toggle('is-visible', on);
          sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
          if (stickyBtn) stickyBtn.tabIndex = on ? 0 : -1;
        };
        // Visible only once the main buy button has scrolled up out of view
        // (not before the visitor has reached it).
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          setVisible(!e.isIntersecting && e.boundingClientRect.top < 0);
        }, { threshold: 0 }).observe(buyRow);
        if (stickyBtn) stickyBtn.addEventListener('click', function () {
          if (stickyBtn.disabled || !form) return;
          if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
        });
        // Hide while the cart drawer is open so the two don't stack.
        document.addEventListener('theme-drawer:open', function () { sticky.style.visibility = 'hidden'; });
        document.addEventListener('theme-drawer:close', function () { sticky.style.visibility = ''; });
      }

      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (!variantInput || !variantInput.value) return;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantInput.value, quantity: parseInt((qtyInput && qtyInput.value) || '1', 10) })
          }).then(function (r) { return r.json(); }).then(function () {
            if (window.keoRefreshCartDrawer) window.keoRefreshCartDrawer(true);
          });
        });
      }
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.keo-pdp').forEach(initPdp);
    }
    initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

    // Size guide: delegated so it survives editor re-renders.
    if (!window.__keoSizeGuideBound) {
      window.__keoSizeGuideBound = true;
      document.addEventListener('click', function (e) {
        var open = e.target.closest('[data-keo-size-guide-open]');
        var close = e.target.closest('[data-keo-size-guide-close]');
        if (!open && !close) return;
        var guide = document.querySelector('[data-keo-size-guide]');
        if (guide) guide.hidden = !!close;
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        var guide = document.querySelector('[data-keo-size-guide]');
        if (guide && !guide.hidden) guide.hidden = true;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keo-product-rail"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRail(root) {
      if (!root || root.dataset.keoRailReady) return;
      root.dataset.keoRailReady = 'true';
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-keo-rail-tab]'));
      var wrap = root.querySelector('[data-keo-rail-panels]');
      if (!tabs.length || !wrap) return;

      function select(tab, focus) {
        if (tab.getAttribute('aria-selected') === 'true') return;
        var next = document.getElementById(tab.getAttribute('aria-controls'));
        var current = wrap.querySelector('[data-keo-rail-panel]:not([hidden])');
        if (!next) return;

        // Hold the current height, swap panels, then animate to the new
        // height so the rest of the page doesn't jump.
        var from = wrap.offsetHeight;
        wrap.style.height = from + 'px';

        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        if (current) current.hidden = true;
        next.hidden = false;
        next.classList.remove('is-entering');
        void next.offsetWidth;
        next.classList.add('is-entering');

        wrap.style.height = 'auto';
        var to = wrap.offsetHeight;
        wrap.style.height = from + 'px';
        requestAnimationFrame(function () {
          wrap.style.height = to + 'px';
        });
        var done = function () { wrap.style.height = ''; wrap.removeEventListener('transitionend', done); };
        wrap.addEventListener('transitionend', done);
        setTimeout(done, 450);

        if (focus) tab.focus({ preventScroll: true });
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function (e) {
          e.preventDefault();
          select(tab, false);
        });
        tab.addEventListener('keydown', function (e) {
          var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!dir) return;
          e.preventDefault();
          select(tabs[(i + dir + tabs.length) % tabs.length], true);
        });
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-keo-rail]').forEach(initRail);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var tab = e.target && e.target.closest && e.target.closest('[data-keo-rail-tab]');
      if (tab) tab.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keo-reel-rail"] && !Shopify.designMode) return;
  try {
    
  // Delegated (document-level) so reels keep working after the theme editor
  // re-renders the section, and each rail uses its own modal.
  (function () {
    if (window.__keoReelsBound) return;
    window.__keoReelsBound = true;
    var lastTrigger = null;

    function modalFor(el) {
      var wrap = el.closest('.shopify-section') || document;
      return wrap.querySelector('[data-keo-reel-modal]');
    }
    function closeModal(modal) {
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      var v = modal.querySelector('[data-keo-reel-modal-video]');
      if (v) { v.pause(); v.removeAttribute('src'); v.load(); }
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
    }
    function openModal(btn) {
      var modal = modalFor(btn);
      if (!modal) return;
      lastTrigger = btn;
      var video = modal.querySelector('[data-keo-reel-modal-video]');
      var poster = modal.querySelector('[data-keo-reel-modal-poster]');
      var hasVideo = !!btn.dataset.video;
      poster.src = btn.dataset.poster || '';
      poster.hidden = hasVideo;
      video.hidden = !hasVideo;
      if (hasVideo) { video.poster = btn.dataset.poster || ''; video.src = btn.dataset.video; }
      modal.querySelector('[data-keo-reel-modal-handle]').textContent = btn.dataset.handle || '';
      modal.querySelector('[data-keo-reel-modal-caption]').textContent = btn.dataset.caption || '';
      var hasProduct = !!btn.dataset.productUrl;
      modal.querySelector('[data-keo-reel-modal-product]').hidden = !hasProduct;
      var link = modal.querySelector('[data-keo-reel-modal-link]');
      link.hidden = !hasProduct;
      link.href = btn.dataset.productUrl || '#';
      modal.querySelector('[data-keo-reel-modal-product-img]').src = btn.dataset.productImage || '';
      modal.querySelector('[data-keo-reel-modal-product-title]').textContent = btn.dataset.productTitle || '';
      modal.querySelector('[data-keo-reel-modal-product-price]').textContent = btn.dataset.productPrice || '';
      modal.hidden = false;
      var close = modal.querySelector('.keo-reel-modal__close');
      if (close) close.focus({ preventScroll: true });
      if (hasVideo) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
    }

    document.addEventListener('click', function (e) {
      var prev = e.target.closest('[data-keo-reel-prev]');
      var next = e.target.closest('[data-keo-reel-next]');
      if (prev || next) {
        var rail = (prev || next).closest('.keo-reel-rail');
        var track = rail && rail.querySelector('[data-keo-reel-track]');
        if (track) track.scrollBy({ left: (prev ? -1 : 1) * track.clientWidth * 0.8, behavior: 'smooth' });
        return;
      }
      var open = e.target.closest('[data-keo-reel-open]');
      if (open) { openModal(open); return; }
      var closeBtn = e.target.closest('[data-keo-reel-close]');
      if (closeBtn) closeModal(closeBtn.closest('[data-keo-reel-modal]'));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-keo-reel-modal]:not([hidden])').forEach(closeModal);
    });
    // Editor: stop any playing video when its section is re-rendered/removed.
    document.addEventListener('shopify:section:unload', function (e) {
      var m = e.target.querySelector && e.target.querySelector('[data-keo-reel-modal]');
      if (m) closeModal(m);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keo-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__keoLookBound) return;
    window.__keoLookBound = true;

    // Hotspot X/Y are a position on the photo itself. The photo is cropped to
    // fill its frame, so work out where the cropped image actually sits.
    function placeSpots(scope) {
      (scope || document).querySelectorAll('.keo-look__media').forEach(function (media) {
        var img = media.querySelector('img');
        var spots = media.querySelectorAll('[data-keo-look-spot]');
        if (!img || !spots.length) return;
        var place = function () {
          var nw = img.naturalWidth, nh = img.naturalHeight;
          var cw = media.clientWidth, ch = media.clientHeight;
          if (!nw || !nh || !cw || !ch) return;
          var cs = getComputedStyle(img);
          var scale = cs.objectFit === 'contain' ? Math.min(cw / nw, ch / nh) : Math.max(cw / nw, ch / nh);
          var w = nw * scale, h = nh * scale;
          var pos = cs.objectPosition.split(' ');
          var px = parseFloat(pos[0]) / 100, py = parseFloat(pos[1] || pos[0]) / 100;
          if (isNaN(px)) px = 0.5;
          if (isNaN(py)) py = 0.5;
          var ox = (cw - w) * px, oy = (ch - h) * py;
          spots.forEach(function (spot) {
            var x = ox + w * (parseFloat(spot.dataset.x) / 100);
            var y = oy + h * (parseFloat(spot.dataset.y) / 100);
            spot.style.left = x + 'px';
            spot.style.top = y + 'px';
            spot.hidden = x < 12 || y < 12 || x > cw - 12 || y > ch - 12;
          });
        };
        if (img.complete) place(); else img.addEventListener('load', place, { once: true });
      });
    }
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(function () { placeSpots(); }, 120); });
    document.addEventListener('shopify:section:load', function (e) { placeSpots(e.target); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { placeSpots(); });
    else placeSpots();

    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('[data-keo-look-form]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var id = form.querySelector('[name="id"]').value;
      if (!btn || btn.disabled) return;
      var label = btn.textContent;
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(id), quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        btn.textContent = 'Added ✓';
        if (window.keoRefreshCartDrawer) window.keoRefreshCartDrawer(true);
      }).catch(function () {
        btn.textContent = 'Try again';
      }).finally(function () {
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1500);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keo-video-testimonials"] && !Shopify.designMode) return;
  try {
    
  // Delegated so it keeps working after the theme editor re-renders the section.
  (function () {
    if (window.__keoTestimonialsBound) return;
    window.__keoTestimonialsBound = true;
    var lastTrigger = null;
    function modalFor(el) {
      var wrap = el.closest('.shopify-section') || document;
      return wrap.querySelector('[data-keo-testimonial-modal]');
    }
    function closeModal(modal) {
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      var video = modal.querySelector('[data-keo-testimonial-video]');
      if (video) { video.pause(); video.removeAttribute('src'); video.load(); }
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-keo-testimonial-open]');
      if (btn) {
        var modal = modalFor(btn);
        if (!modal) return;
        lastTrigger = btn;
        var video = modal.querySelector('[data-keo-testimonial-video]');
        var link = modal.querySelector('[data-keo-testimonial-link]');
        video.poster = btn.dataset.poster || '';
        video.src = btn.dataset.video;
        modal.querySelector('[data-keo-testimonial-caption]').textContent = btn.dataset.caption || '';
        modal.querySelector('[data-keo-testimonial-name]').textContent = btn.dataset.name || '';
        link.hidden = !btn.dataset.productUrl;
        link.href = btn.dataset.productUrl || '#';
        link.textContent = btn.dataset.productTitle ? 'Shop ' + btn.dataset.productTitle : 'Shop';
        modal.hidden = false;
        var c = modal.querySelector('.keo-testimonial-modal__close');
        if (c) c.focus({ preventScroll: true });
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
        return;
      }
      var close = e.target.closest('[data-keo-testimonial-close]');
      if (close) closeModal(close.closest('[data-keo-testimonial-modal]'));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') document.querySelectorAll('[data-keo-testimonial-modal]:not([hidden])').forEach(closeModal);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var m = e.target.querySelector && e.target.querySelector('[data-keo-testimonial-modal]');
      if (m) closeModal(m);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
